import { Loading, Message } from 'element-ui'
import router from '@/router'
import Axios from 'axios'
import store from '@/store'

export const request = Axios.create({
  // baseURL: 'http://192.168.31.188:8013/',
  // baseURL: 'http://192.168.31.60:8888/'
  // baseURL: 'http://192.168.31.188:8019',
  baseURL: 'https://ai.dhzwtec.net',
})
let loadingInstance
request.interceptors.request.use(
  (config) => {
    const token = window.localStorage.getItem('Token')
    loadingInstance = Loading.service({ fullscreen: true })
    // 判断是否存在token，如果不存在的话，并且不是访问登录接口，则跳转到登录界面，否则执行下面的函数
    // 判断是否存在token，如果存在的话，则每个http header都加上token，否则不添加
    if (!token) {
      if (config.url.indexOf('/api/Admin/Login') == -1) {
        Message.error('请重新登录')
        router.push({
          path: '/login',
          query: {
            redirect: router.currentRoute.fullPath,
          },
        })
        return config
      } else {
        // 没有token且是登录接口，则去请求登录接口
        return config
      }
    } else {
      if (config.url.indexOf('/api/Admin/Login') == -1) {
        config.headers['Authorization'] = 'Bearer ' + token
      } else {
        // 有token，且是登录接口，则不添加token，去请求登录接口
        return config
      }
    }

    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)
request.interceptors.response.use(
  (response) => {
    loadingInstance.close()
    // 返回的code为1时，表示成功，否则失败
    if (
      response?.data?.Code == 1 &&
      (response.config.url.indexOf('/Add') > -1 ||
        response.config.url.indexOf('/ChangePwd') > -1 ||
        response.config.url.indexOf('/Delete') > -1 ||
        response.config.url.indexOf('/Edit') > -1)
    ) {
      Message.success(response?.data?.Message)
    } else if (response?.data?.Code == 3) {
      Message.error(response?.data?.Message)
    }
    return response
  },
  async (err) => {
    // 返回状态码不是200，与服务器连接失败
    loadingInstance.close()
    if (err.code == 'ERR_NETWORK') {
      if (store.state.flag1) {
        Message.error(err.message)
        store.commit('changeFlagToF')
      }
      router.push('/login')
      return
    } else if (err.response.status == 400) {
      if (store.state.flag1) {
        Message.error(err.response.data.title)
        store.commit('changeFlagToF')
      }
      router.push('/login')
      return err
    } else if (err.response.status == 401) {
      if (store.state.flag1) {
        Message.error('token过期请重新登录')
        localStorage.removeItem('Token')
        store.commit('changeFlagToF')
      }
      router.push('/login')

      return
    }
    return Promise.reject(err)
  }
)

export const pretty = function (promise) {
  return promise
    .then((data) => {
      return [data, undefined]
    })
    .catch((err) => {
      ;[undefined, err]
    })
}
